import {useAuthStore} from "../store/useAuth.store";
import useCurrencyStore from "../store/useCurrency.store";
import {parseNationalIdType} from "../util/identityValidation";
import useGetUserInfo from "./useGetUserInfo";
import useGetAccountPagoMovil from "./wallet/useGetAccountPagoMovil";

const isEmpty = val => val === undefined || val === null || val === "" || val === "null";

const hasBasicProfile = userData => {
  const firstName = userData?.firstName || userData?.given_name;
  const lastName = userData?.lastName || userData?.family_name;
  const birthdate = userData?.birthdate || userData?.birth_date;

  return !isEmpty(userData?.nationalID) && !isEmpty(firstName) && !isEmpty(lastName) && !isEmpty(birthdate);
};

/**
 * True when the authenticated VES user still needs post-login profile onboarding.
 * - RUT: national ID + name + birthdate.
 * - V / E: national ID + name + birthdate + phone + Pago Móvil account.
 */
const useNeedsProfileOnboarding = () => {
  const authStatus = useAuthStore(state => state.authStatus);
  const {selectedCurrency} = useCurrencyStore();
  const {data: userData, isLoading: userLoading, isSuccess: userSuccess} = useGetUserInfo();
  const {data: pmAccounts, isLoading: pmLoading, isSuccess: pmSuccess} = useGetAccountPagoMovil();

  const isAuthenticated = authStatus === "authenticated";
  const isPagoMovilApplicable = !selectedCurrency?.id || selectedCurrency.id === "VES";
  const isLoading = isAuthenticated && isPagoMovilApplicable && (userLoading || pmLoading);
  const isReady = userSuccess && (!isPagoMovilApplicable || pmSuccess);

  let needsOnboarding = false;

  if (isAuthenticated && isPagoMovilApplicable && isReady) {
    const profileComplete = hasBasicProfile(userData);

    if (!profileComplete) {
      needsOnboarding = true;
    } else {
      const idType = parseNationalIdType(userData?.nationalID);

      if (idType === "V" || idType === "E") {
        const hasPhone = !isEmpty(userData?.phoneNumber);
        const hasPm = (pmAccounts?.length ?? 0) > 0;
        needsOnboarding = !hasPhone || !hasPm;
      }
    }
  }

  return {
    needsOnboarding,
    isLoading,
    isReady,
    isPagoMovilApplicable,
    isAuthenticated,
    userData,
    pmAccounts,
  };
};

export default useNeedsProfileOnboarding;
